/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcSearchRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M15.091 5.82a6.556 6.556 0 1 0-9.271 9.272 6.556 6.556 0 0 0 9.27-9.272M4.547 4.547a8.356 8.356 0 0 1 12.42 11.147l4.669 4.67a.9.9 0 1 1-1.273 1.273l-4.67-4.67A8.357 8.357 0 0 1 4.548 4.547"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcSearchRegular;
